import { render, staticRenderFns } from "./BalanceStatement-1.vue?vue&type=template&id=c8959db8"
import script from "./BalanceStatement-1.vue?vue&type=script&lang=js"
export * from "./BalanceStatement-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports